import * as React from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import BookmarkAddedIcon from "@mui/icons-material/BookmarkAdded";

export default function TemporaryDrawer({ open, toggleDrawer, setEditorValue,setLanguage,setResponse }) {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const token = localStorage.getItem("accessToken");

      if (!user || !token) {
        toast.error("Authentication required. Please log in to access data.");
        return;
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/user-results/?filters[user_id][$eq]=${user.id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const result = await response.json();
      setData(result.data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (open) {
      fetchData();
    }
  }, [open]);

  const handleItemClick = (item) => {
    if (item.attributes?.code_execution) {
      setEditorValue(item.attributes.code_execution);
      setLanguage(item.attributes.language);
      setResponse({ result: item.attributes.code_output });
      // Update the Monaco Editor with clicked item data
    } else {
      toast.warning("No code available for this item.");
    }
  };

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
      <List>
        <ListItem>
          <ListItemText sx={{ borderBottom: "1px solid black", fontWeight: "700" }} primary="Saved Data" />
        </ListItem>
      </List>
      <List>
        {loading ? (
          <ListItem>
            <ListItemText primary="Loading..." />
          </ListItem>
        ) : data.length > 0 ? (
          data.map((item) => (
            <ListItem key={item.id} disablePadding>
              <ListItemButton onClick={() => handleItemClick(item)}>
                <ListItemIcon>
                  <BookmarkAddedIcon />
                </ListItemIcon>
                <ListItemText primary={item.attributes?.title || "Untitled"} />
              </ListItemButton>
            </ListItem>
          ))
        ) : (
          <ListItem>
            <ListItemText primary="No data available" />
          </ListItem>
        )}
      </List>
      <Divider />
    </Box>
  );

  return <Drawer open={open} onClose={toggleDrawer(false)}>{DrawerList}</Drawer>;
}
